/* Gummy Gardens — Gigi loops (2026-10-08, founder request).
   Every Gigi still on the site (homepage sections, About page) gets a subtle seamless looping video laid over it.
   The original <img> stays in place as the poster, the alt text and the fallback: the video is only added on top,
   muted / playsinline / loop, lazy-loaded when the image nears the viewport, paused when off screen, and never
   added when the visitor prefers reduced motion. Videos are original-quality Shopify Files (H.264 MP4 + WebM). */
(function () {
  var LOOPS = {
    "gg-about-gigi-no-more-shaker-pineapple": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/f3debab6e38e42ccb1123bad5df9637c.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-about-gigi-no-more-shaker-pineapple-loop.webm?v=1791426877"
    },
    "gg-about-gigi-promise-tropical": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/9f35a09497d14031bc6428b10c5d4d75.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-about-gigi-promise-tropical-loop.webm?v=1791426906"
    },
    "gg-home-gigi-faq-hoodie": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/eb29d3d62a46445bad2ed1077cfdf73f.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-home-gigi-faq-hoodie-loop-v2.webm?v=1792605723"
    },
    "gg-home-gigi-guarantee-cherry-apple-v2": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/adf9d0a2ae054f4eac78d8e7869bf6fc.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-home-gigi-guarantee-cherry-apple-v2-loop.webm?v=1791426945"
    },
    "gg-home-gigi-kitchen-mandarin-orange": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/029f8939233a43428af11d2046eec34c.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-home-gigi-kitchen-mandarin-orange-loop.webm?v=1791426965"
    },
    "gg-home-gigi-lab-coat-mixed-berry": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/ef0e145873ef459db8d9e5a1ba014254.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-home-gigi-lab-coat-mixed-berry-loop.webm?v=1791426989"
    },
    "gg-home-gigi-on-the-go-tropical-v2": {
      "mp4": "https://cdn.shopify.com/videos/c/o/v/c801efc8cbf345839cb8f73b4da7370e.mp4",
      "webm": "https://cdn.shopify.com/s/files/1/0647/5943/1283/files/gg-home-gigi-on-the-go-tropical-v2-loop.webm?v=1791427300"
    }
  };
  try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}

  function keyFor(img) {
    var s = (img.currentSrc || img.src || '') + ' ' + (img.getAttribute('srcset') || '');
    for (var k in LOOPS) { if (s.indexOf('/' + k + '.') !== -1) return k; }
    return null;
  }

  function attach(img, k) {
    if (img.getAttribute('data-gg-loop')) return;
    img.setAttribute('data-gg-loop', k);
    var parent = img.parentElement; if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    var cs = getComputedStyle(img);
    var v = document.createElement('video');
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
    v.setAttribute('preload', 'none'); v.setAttribute('aria-hidden', 'true'); v.setAttribute('tabindex', '-1');
    v.setAttribute('disablepictureinpicture', ''); v.className = 'gg-gigi-loop';
    v.poster = img.currentSrc || img.src;
    function place() {
      var pr = parent.getBoundingClientRect(), r = img.getBoundingClientRect();
      v.style.cssText = 'position:absolute;pointer-events:none;opacity:0;transition:opacity .45s ease;background:transparent;' +
        'left:' + (r.left - pr.left - parent.clientLeft) + 'px;top:' + (r.top - pr.top - parent.clientTop) + 'px;width:' + r.width + 'px;height:' + r.height + 'px;' +
        'object-fit:' + (cs.objectFit || 'cover') + ';object-position:' + (cs.objectPosition || '50% 50%') + ';' +
        'border-radius:' + cs.borderRadius + ';z-index:' + (cs.zIndex === 'auto' ? 1 : cs.zIndex) + ';' + (v.dataset.on ? 'opacity:1;' : '');
    }
    place();
    img.insertAdjacentElement('afterend', v);
    if (window.ResizeObserver) new ResizeObserver(place).observe(img); else window.addEventListener('resize', place);
    v.addEventListener('playing', function () { v.dataset.on = '1'; v.style.opacity = '1'; });
    var loaded = false;
    function load() {
      if (loaded) return; loaded = true;
      var src = LOOPS[k];
      // MP4 (H.264) first: plays everywhere incl. iOS Safari; WebM is the fallback source.
      var s2 = document.createElement('source'); s2.src = src.mp4; s2.type = 'video/mp4'; v.appendChild(s2);
      if (src.webm) { var s1 = document.createElement('source'); s1.src = src.webm; s1.type = 'video/webm'; v.appendChild(s1); }
      v.setAttribute('preload', 'auto'); v.load();
    }
    function play() { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) play(); else if (loaded) v.pause(); });
      }, { rootMargin: '300px 0px' }).observe(img);
    } else { play(); }
  }

  function scan() {
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) { var k = keyFor(imgs[i]); if (k) attach(imgs[i], k); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
})();
